import styled from "styled-components"

export const StartSessionContainer = styled.div`
  > div {
    margin-bottom: 2rem;
  }
`
